/* eslint-disable max-len */
import moment from 'moment'
import React, { useContext, useState } from 'react'
import AnimatedModel from '../../../../../components/Animation/AnimatedModel';
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt';
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId';
import { dataService } from '../../../../../services/data.services';
import GlobalContext from '../../../../../components/Context/GloablContext';

export default function TableBody({rowItem, getFinancialYearRecodes, isRole}) {
    const {setToastmessage, setFyBtnLoading, isInactiveBranch, setToastErrorMessage} = useContext(GlobalContext);
    const [changeStatusButton, setChangeStatusButton] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false)
    const [changedOngoingFY, setChangedOngoingFY] = useState({})
    const [ongoingFY, setOngoingFY] = useState({})

    /**
     * The function `handelChangeStatusButton` toggles the value of `changeStatusButton`.
     */
    const handelChangeStatusButton = () => {
        setChangeStatusButton(!changeStatusButton)
    }

    const fetchFYStatus = async (id) => {
        try {
            setFyBtnLoading(true)
            const branch_id = id ?? await GetBranchId();
            const fydetails = await dataService.GetAPI(`financial-years?branch_id=${branch_id}`);


            let closedFY = fydetails?.data?.data?.financial_years.filter(item => item.status === "closed");
            const res = await dataService.GetAPI(`financial-years?branch_id=${branch_id}&filter=true&status=ongoing&sort=status%2Basc`, true);
            for (const fy of closedFY) {
                if (ongoingFY?.name === fy.name && ongoingFY?.status !== fy.status) {
                    const newOngoingFY = res?.data?.data?.financial_years?.[0];
                    setOngoingFY(newOngoingFY);
                    if (newOngoingFY) {
                        localStorage.setItem('FY_details', JSON.stringify(newOngoingFY));
                        //broadcastChannel.postMessage({ type: 'switch_fy' });
                    }
                }
            }

            if (Object.keys(ongoingFY).length === 0) { // If ongoingFY wasn't found in closedFY
                const newOngoingFY = res?.data?.data?.financial_years?.[0];
                setOngoingFY(newOngoingFY);
                if (newOngoingFY) {
                    localStorage.setItem('FY_details', JSON.stringify(newOngoingFY));
                    //broadcastChannel.postMessage({ type: 'switch_fy' });
                }
            }
            setFyBtnLoading(false)
        } catch (error) {
            console.error('Error while checking FY status:', error);
        }
    };
    
    /**
     * The function `handleOnClickComplete` is an asynchronous function that sets the loading state of
     * a button, retrieves a branch ID, makes a PATCH request to an API endpoint, handles the response
     * and error, and updates some state variables.
     */
    const handleOnCLickComplete = async () => {
        const broadcastChannel = new BroadcastChannel('tab-reload-channel');
        setLoadingButton(true)
        const branch_id = await GetBranchId()
        try {
            const response = await dataService.PatchAPI(changedOngoingFY, `financial-years/${branch_id}`);
            if(response?.message === 'Forbidden') throw error
            setToastmessage("Status changed successfully");
            broadcastChannel.postMessage({ type: 'switch_fy' });
            getFinancialYearRecodes()
            setChangeStatusButton(false)
            setLoadingButton(false);
            await fetchFYStatus()


        } catch (error) {
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            setChangeStatusButton(false)
            setLoadingButton(false);
            console.error('An error occurred:', error);
        }
    }
    return (
        <>
            <tr id="list-items" class="cursor-pointer ">
                <td class="text-start">{rowItem?.name}</td>
                <td class="text-start">{moment(rowItem?.start_date).utc().format('MMM DD, YYYY')}</td>
                <td class="text-start">{moment(rowItem?.end_date).utc().format('MMM DD, YYYY')}</td>
                <td class="table-cell">
                    <div className='flex justify-start'>
                        <div class={`${rowItem?.status === "open" ? "bg-[#C5FFD5]" : rowItem?.status === "upcoming" ? "bg-[#FAC39B]" : rowItem?.status === "ongoing" ? "bg-[#FFEEB0]" : "bg-[#C2DCEF]"} w-fit rounded flex items-center justify-center py-1 px-2.5`}>
                            <img loading="lazy" decoding="async" src={rowItem?.status === "open" ? "/images/successDot.svg" : rowItem?.status === "upcoming" ? "/images/upcoming_dot.svg" : rowItem?.status === "ongoing" ? "/images/draft-img.svg" : "/images/bluedot.svg"} alt="icon "/>
                            <span class="pl-1">{ rowItem?.status.charAt(0).toUpperCase() + rowItem?.status.slice(1)}</span>
                        </div>
                    </div>
                </td>
                
                {!isRole && <td class="text-center prevent-click">
                    {rowItem?.status === "open" && <div class="relative flex items-center justify-center prevent-click" data-te-dropdown-position="dropstart">
                        <button
                            id='mark_closed'
                            disabled={isRole || isInactiveBranch}
                            onClick={() => {handelChangeStatusButton(); 
                                setChangedOngoingFY({
                                    "status": "closed",
                                    "name": rowItem?.name,
                                })}}
                            class={`list-actn-btn`} 
                        >
                            Mark as Closed
                        </button>
                    </div>}
                </td>}
            </tr>
            
            {changeStatusButton && <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleOnCLickComplete}
                        handleClose={handelChangeStatusButton}
                        tittle={"Mark as Closed"}
                        additionalMessage={"Once the status is marked as ‘Closed’, you cannot add or modify any of the data for the Financial Year."}
                        buttonName="Proceed"
                        loadingActivation={loadingButton}
                        message="Would you like to proceed?"
                        dialogueWidth={'500px'}
                        textPosition={'text-start'}
                    />
                }
            />}
        </>
    )
}
